<micro-select-combo #sel
              placeholder="Payment Carrier Type"
              [mode]="mode"
              [(id)]="paymentCarrierTypeId"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
>
</micro-select-combo>
